// frontend/src/components/chat/patient-panel/hooks/usePatientSignals.ts
import { useMemo } from 'react'
import { SemanticExtraction } from '../../../../contexts/ChatContext'
import { Signal, SignalSeverity } from '../types'

export const usePatientSignals = (extractions: SemanticExtraction[]): Signal[] => {
  return useMemo(() => {
    const signals: Signal[] = []
    if (!Array.isArray(extractions)) return signals

    extractions.forEach((e, index) => {
      let severity: SignalSeverity | null = null

      // Abnormal labs = high severity
      if (e.is_abnormal) {
        severity = 'high'
      }
      // High-risk meds = medium severity
      else if (e.is_high_risk) {
        severity = 'medium'
      }
      // Top priority problems = high severity
      else if (e.category === 'problem' && e.priority && e.priority <= 2) {
        severity = 'high'
      }
      // High-confidence findings = info
      else if (e.category === 'finding' && e.confidence >= 0.9) {
        severity = 'info'
      }

      if (severity) {
        signals.push({
          id: `signal-${index}`,
          content: e.content,
          severity,
          extraction: e,
        })
      }
    })

    // Limit to 5 signals, prioritize by severity
    return signals
      .sort((a, b) => {
        const order = { high: 0, medium: 1, info: 2 }
        return order[a.severity] - order[b.severity]
      })
      .slice(0, 5)
  }, [extractions])
}
